
export default {
    name: 'caisse-info',
    components: {},
    props: {
        op_info: Object
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}


